import React from 'react';
import VerticalBox from "../../../../../../core/components/box/vertical";
import Avatar from "../../../../../../core/components/avatar";
import Typo from "../../../../../../core/components/typo";
import {ScoreBadge} from "../../../../../../core/components/badge";
import RenderIf from "../../../../../../core/components/render-if";
import ClubViewLeftClubModal from "../left-organisation-modal";
import {getActiveOrganisation, setActiveOrganisation} from "../../../../../Auth/services/organisationService";
import {useNavigate} from "react-router-dom";
import Button from "../../../../../../core/components/button";
import __ from "../../../../../../core/utils/translate/translate";
import JoinToClubCanceRequest from "../../../../person/main/components/join-to-club/components/cancel-request";

export default function OrganizationCard({organisation}) {
    const navigate = useNavigate();
    const activeOrganization = getActiveOrganisation();

    return (
        <VerticalBox className="w-full shrink-0 p-4 rounded-3xl bg-white">
            <div className="flex w-full items-center gap-4">
                <Avatar
                    image={organisation?.organization?.logoDetail?.url}
                    name={organisation?.organization?.name ?? ""}
                    className="rounded-3xl"
                    size="xl"
                    avatarClassName="rounded-3xl"
                />

                <div className="flex flex-col space-y-3">
                    <Typo as="h2" weight="bold" className="ui-clamp-1 w-full flex-1" type="primary">
                        {organisation?.organization?.name}
                    </Typo>
                    <Typo as="h4" className="ui-clamp-1 w-full flex-1" type="primary">
                        {organisation?.organization?.settingsPretty?.description}
                    </Typo>

                </div>
            </div>
            <div className="flex justify-between flex-wrap items-center w-full gap-2">
                <div className={'flex gap-2'}>
                    <Typo as="p" className="ui-clamp-3 my-auto text-black" size={'xs'}>
                        امتیاز کسب شده شما در این کانون:
                    </Typo>
                    <ScoreBadge amount={organisation?.totalExperience ?? 0} type="xp"/>
                </div>
                <RenderIf cond={organisation?.status === 'pending'}>
                    <div className={'flex flex-col items-center sm:m-0 m-auto'}>
                        <Typo size={'xs'} type="secondary">
                            درخواست شما برای عضویت در حال بررسی است
                        </Typo>
                        <div className="flex items-center gap-2">
                            <Typo onClick={() => {
                                navigate(0)
                            }} className="hover:underline" size="xs">
                                {__("Click here to check the request status")}
                            </Typo>
                            <Typo>|</Typo>
                            <JoinToClubCanceRequest organisation={organisation}/>
                        </div>
                    </div>
                </RenderIf>
                <RenderIf cond={organisation?.status !== 'pending'}>
                    <div className={'flex gap-2 items-center'}>
                        <Button type="danger" containerClassName="self-end" size={'sm'} scale="fit" onClick={() => {
                            setActiveOrganisation(organisation)
                            navigate('/')
                        }}>
                            انتخاب کانون
                        </Button>
                    </div>
                </RenderIf>
            </div>
            <RenderIf cond={organisation?.status !== 'pending'}>
                <div className="flex items-center pt-4 border-t border-gray-300 gap-2">
                    <Typo size={'xs'} type="primary">
                        دیگه عضو این کانون نیستی؟
                    </Typo>
                    <ClubViewLeftClubModal organisation={organisation} />
                </div>
            </RenderIf>
        </VerticalBox>
    );
}